import { Button, Box } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { Link } from "react-router-dom";
import { getCustomButtonVariant } from "utils/uiconfighelper";

const QuickLink = ({ title, to }: { title: string; to: string }) => {
  const { user } = useTenant();

  return (
    <Box w={"100%"}>
      <Link to={to}>
        <Button variant={getCustomButtonVariant(user)} w={"100%"}>
          {title}
        </Button>
      </Link>
    </Box>
  );
};

export default QuickLink;
